// @flow
import React from "react";
import styled from "styled-components";
import { rtl } from "../common/styled-mixins";

import spinnerImg from "../../images/spinner-simple.png";
import spinnerImgAccent from "../../images/spinner-simple-accent.png";

const Container = styled.div`
  color: ${({ theme }) =>
    theme.mode === "light" ? "#3B9478" : theme.accent || "#ffffff"};
`;

// prettier-ignore
export default styled.span`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 1em;
  height: 1em;
  margin-top: -0.25em;
  ${rtl("margin-right", props => props.noMargin ? 0 : "0.6em")};
  overflow: hidden;
  background: transparent url(${props => (props.accent ? spinnerImgAccent : spinnerImg)}) center no-repeat;
  background-size: contain;
  border: none;
  border-radius: 50%;
  transform: rotate(0deg) translateZ(0);
  transform-origin: 50%;
  animation: spin 1s infinite ease-in forwards;

  @keyframes spin {
    to {
      transform: rotate(360deg) translateZ(0);
    }
  }
`;

const Icon = styled.svg`
  display: block;
`;

type Props = {
  width?: string,
  height?: string,
  fill?: string
};

export const NewSimpleSpinnerIcon = ({
  width = "1em",
  height = "1em",
  fill = "currentColor"
}: Props) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 50 50"
    enableBackground="new 0 0 50 50"
    xmlSpace="preserve"
    fill={fill}
  >
    <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
      <animateTransform
        attributeType="xml"
        attributeName="transform"
        type="rotate"
        from="0 25 25"
        to="360 25 25"
        dur="0.6s"
        repeatCount="indefinite"
      />
    </path>
  </Icon>
);

export const NewSimpleSpinner = (props) => (
  <Container>
    <NewSimpleSpinnerIcon {...props} />
  </Container>
);



// WEBPACK FOOTER //
// ./src/components/Spinners/SimpleSpinner.js